module.exports = __webpack_public_path__ + "img/bonaire.3f06ada4.svg";